!function (e, n) {
  "object" == typeof exports && "object" == typeof module ? module.exports = n(require("prop-types"), require("react")) : "function" == typeof define && define.amd ? define(["prop-types", "react"], n) : "object" == typeof exports ? exports["react-redux-spinner"] = n(require("prop-types"), require("react")) : e["react-redux-spinner"] = n(e["prop-types"], e.react);
}(this, function (e, n) {
  return function (e) {
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    var t = {};
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }, n.p = "/dist/", n(n.s = 0);
  }([function (e, n, t) {
    t(1), e.exports = t(2);
  }, function (e, n) {}, function (e, n, t) {
    "use strict";

    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.endAll = n.end = n.begin = n.pendingTask = n.Spinner = n.pendingTasksReducer = n.configurablePendingTasksReducer = void 0;
    var r = t(3),
      o = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(t(4));
    n.configurablePendingTasksReducer = r.configurablePendingTasksReducer, n.pendingTasksReducer = r.pendingTasksReducer, n.Spinner = o.default, n.pendingTask = r.actionKey, n.begin = r.begin, n.end = r.end, n.endAll = r.endAll;
  }, function (e, n, t) {
    "use strict";

    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    var r = "@@react-redux-spinner/pending-task",
      o = "@@react-redux-spinner/begin",
      i = "@@react-redux-spinner/end",
      s = "@@react-redux-spinner/end-all",
      u = function u() {
        var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).actionKeyPath,
          n = void 0 === e ? [] : e;
        return function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
            t = arguments[1],
            u = n.reduce(function (e, n) {
              return e[n];
            }, t);
          if (!u) return e;
          if (u[r] === o) return e + 1;
          if (u[r] === i) {
            if (e - 1 < 0) throw new RangeError("Number of pending tasks decreased below zero. This indicates you have an error in your code. 'end' is called more often than 'begin'.");
            return e - 1;
          }
          return u[r] === s ? 0 : e;
        };
      },
      a = u();
    n.actionKey = r, n.begin = o, n.end = i, n.endAll = s, n.pendingTasksReducer = a, n.configurablePendingTasksReducer = u;
  }, function (e, n, t) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    var o = function () {
        function e(e, n) {
          for (var t = 0; t < n.length; t++) {
            var r = n[t];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (n, t, r) {
          return t && e(n.prototype, t), r && e(n, r), n;
        };
      }(),
      i = r(t(5)),
      s = r(t(6)),
      u = r(t(7)),
      a = function (e) {
        function n() {
          return function (e, n) {
            if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
          }(this, n), function (e, n) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !n || "object" != typeof n && "function" != typeof n ? e : n;
          }(this, (n.__proto__ || Object.getPrototypeOf(n)).apply(this, arguments));
        }
        return function (e, n) {
          if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
          e.prototype = Object.create(n && n.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
        }(n, i.default.Component), o(n, [{
          key: "componentDidMount",
          value: function value() {
            var e = this,
              n = this.context.store,
              t = this.props.config;
            this.previousPendingTasks = n.getState().pendingTasks, u.default.configure(t), this.disposeStoreSubscription = n.subscribe(function () {
              var t = n.getState().pendingTasks - e.previousPendingTasks;
              t > 0 && u.default.start(), t < 0 && u.default.inc(), 0 === n.getState().pendingTasks && u.default.done(), e.previousPendingTasks = n.getState().pendingTasks;
            });
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.disposeStoreSubscription();
          }
        }, {
          key: "render",
          value: function value() {
            return !1;
          }
        }]), n;
      }();
    a.contextTypes = {
      store: s.default.shape({
        getState: s.default.func.isRequired
      })
    }, a.propTypes = {
      config: s.default.object
    }, a.defaultProps = {
      config: {}
    }, n.default = a;
  }, function (e, t) {
    e.exports = n;
  }, function (n, t) {
    n.exports = e;
  }, function (e, n, t) {
    var r, o;
    !function (i, s) {
      void 0 !== (o = "function" == typeof (r = s) ? r.call(n, t, n, e) : r) && (e.exports = o);
    }(0, function () {
      function e(e, n, t) {
        return e < n ? n : e > t ? t : e;
      }
      function n(e) {
        return 100 * (-1 + e);
      }
      function t(e, n) {
        return ("string" == typeof e ? e : i(e)).indexOf(" " + n + " ") >= 0;
      }
      function r(e, n) {
        var r = i(e),
          o = r + n;
        t(r, n) || (e.className = o.substring(1));
      }
      function o(e, n) {
        var r,
          o = i(e);
        t(e, n) && (r = o.replace(" " + n + " ", " "), e.className = r.substring(1, r.length - 1));
      }
      function i(e) {
        return (" " + (e.className || "") + " ").replace(/\s+/gi, " ");
      }
      function s(e) {
        e && e.parentNode && e.parentNode.removeChild(e);
      }
      var u = {};
      u.version = "0.2.0";
      var a = u.settings = {
        minimum: .08,
        easing: "ease",
        positionUsing: "",
        speed: 200,
        trickle: !0,
        trickleRate: .02,
        trickleSpeed: 800,
        showSpinner: !0,
        barSelector: '[role="bar"]',
        spinnerSelector: '[role="spinner"]',
        parent: "body",
        template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
      };
      u.configure = function (e) {
        var n, t;
        for (n in e) void 0 !== (t = e[n]) && e.hasOwnProperty(n) && (a[n] = t);
        return this;
      }, u.status = null, u.set = function (t) {
        var r = u.isStarted();
        t = e(t, a.minimum, 1), u.status = 1 === t ? null : t;
        var o = u.render(!r),
          i = o.querySelector(a.barSelector),
          s = a.speed,
          d = a.easing;
        return o.offsetWidth, c(function (e) {
          "" === a.positionUsing && (a.positionUsing = u.getPositioningCSS()), f(i, function (e, t, r) {
            var o;
            return o = "translate3d" === a.positionUsing ? {
              transform: "translate3d(" + n(e) + "%,0,0)"
            } : "translate" === a.positionUsing ? {
              transform: "translate(" + n(e) + "%,0)"
            } : {
              "margin-left": n(e) + "%"
            }, o.transition = "all " + t + "ms " + r, o;
          }(t, s, d)), 1 === t ? (f(o, {
            transition: "none",
            opacity: 1
          }), o.offsetWidth, setTimeout(function () {
            f(o, {
              transition: "all " + s + "ms linear",
              opacity: 0
            }), setTimeout(function () {
              u.remove(), e();
            }, s);
          }, s)) : setTimeout(e, s);
        }), this;
      }, u.isStarted = function () {
        return "number" == typeof u.status;
      }, u.start = function () {
        u.status || u.set(0);
        var _e = function e() {
          setTimeout(function () {
            u.status && (u.trickle(), _e());
          }, a.trickleSpeed);
        };
        return a.trickle && _e(), this;
      }, u.done = function (e) {
        return e || u.status ? u.inc(.3 + .5 * Math.random()).set(1) : this;
      }, u.inc = function (n) {
        var t = u.status;
        return t ? ("number" != typeof n && (n = (1 - t) * e(Math.random() * t, .1, .95)), t = e(t + n, 0, .994), u.set(t)) : u.start();
      }, u.trickle = function () {
        return u.inc(Math.random() * a.trickleRate);
      }, function () {
        var e = 0,
          n = 0;
        u.promise = function (t) {
          return t && "resolved" !== t.state() ? (0 === n && u.start(), e++, n++, t.always(function () {
            0 === --n ? (e = 0, u.done()) : u.set((e - n) / e);
          }), this) : this;
        };
      }(), u.render = function (e) {
        if (u.isRendered()) return document.getElementById("nprogress");
        r(document.documentElement, "nprogress-busy");
        var t = document.createElement("div");
        t.id = "nprogress", t.innerHTML = a.template;
        var o,
          i = t.querySelector(a.barSelector),
          c = e ? "-100" : n(u.status || 0),
          d = document.querySelector(a.parent);
        return f(i, {
          transition: "all 0 linear",
          transform: "translate3d(" + c + "%,0,0)"
        }), a.showSpinner || (o = t.querySelector(a.spinnerSelector)) && s(o), d != document.body && r(d, "nprogress-custom-parent"), d.appendChild(t), t;
      }, u.remove = function () {
        o(document.documentElement, "nprogress-busy"), o(document.querySelector(a.parent), "nprogress-custom-parent");
        var e = document.getElementById("nprogress");
        e && s(e);
      }, u.isRendered = function () {
        return !!document.getElementById("nprogress");
      }, u.getPositioningCSS = function () {
        var e = document.body.style,
          n = "WebkitTransform" in e ? "Webkit" : "MozTransform" in e ? "Moz" : "msTransform" in e ? "ms" : "OTransform" in e ? "O" : "";
        return n + "Perspective" in e ? "translate3d" : n + "Transform" in e ? "translate" : "margin";
      };
      var c = function () {
          function e() {
            var t = n.shift();
            t && t(e);
          }
          var n = [];
          return function (t) {
            n.push(t), 1 == n.length && e();
          };
        }(),
        f = function () {
          function e(e) {
            return e = function (e) {
              return e.replace(/^-ms-/, "ms-").replace(/-([\da-z])/gi, function (e, n) {
                return n.toUpperCase();
              });
            }(e), r[e] || (r[e] = function (e) {
              var n = document.body.style;
              if (e in n) return e;
              for (var r, o = t.length, i = e.charAt(0).toUpperCase() + e.slice(1); o--;) if ((r = t[o] + i) in n) return r;
              return e;
            }(e));
          }
          function n(n, t, r) {
            t = e(t), n.style[t] = r;
          }
          var t = ["Webkit", "O", "Moz", "ms"],
            r = {};
          return function (e, t) {
            var r,
              o,
              i = arguments;
            if (2 == i.length) for (r in t) void 0 !== (o = t[r]) && t.hasOwnProperty(r) && n(e, r, o);else n(e, i[1], i[2]);
          };
        }();
      return u;
    });
  }]);
});